import React from 'react';

export const disabilitiesOrientation = (
  <div>
    <h3 className="vads-u-padding-top--0">
      Add your disabilities and conditions
    </h3>
    <p>
      On the next few screens, we’ll ask you about the disabilities and
      conditions you’re claiming, in two parts.
    </p>
    <ol>
      <li>
        Rated service-connected disabilities. We’ll ask you to select all the
        disabilities you’re claiming for increase compensation.
      </li>
      <li>New conditions connected to your service.</li>
    </ol>
    <p>
      Once you’ve listed all the disabilities and conditions you’re claiming,
      we’ll ask more specific questions about each of them.
    </p>
  </div>
);
